import { db, auth } from '../firebaseInit'

export default {
  state: {
    defaultFilters: null,
    notifications: [],
    loading: false,
    user: null,
    log: [],
    error: null,
    authError: null,
    clientSettings: null // Get From Main
  },
  mutations: {
    setDefaultFilters (state, payload) {
      state.defaultFilters = payload
    },
    updateUser (state, payload) { // Pass the payload with the new user object details i.e. payload = { filters: XXXXX }
      state.user = { ...state.user, ...payload }
    },
    updateUserFilters (state, payload) {
      if (state.user.filters) {
        state.user.filters = { ...state.user.filters, ...payload }
      } else {
        state.user.filters = payload
      }
    },
    clearNotification (state, payload) {
      state.notifications.splice(payload, 1)
    },
    notifications (state, payload) {
      state.notifications = payload
    },
    commitLog (state, payload) {
      state.log.push(payload)
    },
    setUser (state, payload) {
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload.error
    },
    clearError (state) {
      state.error = null
    },
    clearUser (state) {
      state.user = null
    },
    clientSettings (state, payload) {
      state.clientSettings = payload
    }
  },
  actions: {
    saveUserFilters ({ commit, getters, dispatch }, payload) { // Pass filter as i.e  { scheduler: { FILTERS } OR preConstruction: { FILTERS } OR construction: { FILTERS }
      const user = getters.user
      // Insure Payload does not contain any "undefined"
      const payloadKeys = Object.keys(payload)
      payloadKeys.forEach(key => {
        const subKeys = Object.keys(payload[key])
        subKeys.forEach(subKey => {
          if (payload[key][subKey] === undefined) {
            payload[key][subKey] = null
          }
        })
      })
      const payloadKey = Object.keys(payload)
      let payloadValue = Object.values(payload)[0]
      let firebaseKey = 'filters.' + payloadKey[0]
      if (payloadKey.length > 1) firebaseKey = 'filters' // If loading default filters at startup
      if (payloadKey.length > 1) payloadValue = payload // If loading default filters at startup
      db.collection('users').doc(user.id).update({ [firebaseKey]: payloadValue })
      .then(() => {
        commit('updateUserFilters', payload)
        dispatch('loadDefaultFilters')
      })
    },
    loadDefaultFilters ({ commit, dispatch, state }) { // If a new user has no filters - Set new default ones
      const filters = {
        scheduler: {
          showOnlyMyTasks: false,
          showOnlyMyProjects: false,
          filterVendors: null,
          filterVendorTypes: null,
          filterTasks: null,
          filterBuilders: null,
          filterPCTofProject: [0, 100],
          filterProjects: null,
          filterProjectTypes: 'Construction',
          filterProjectPhases: null,
          filterUsers: null,
          filterUserProjects: null,
          filterTaskStatus: ['Not Started', 'Started', 'On Hold', 'Flagged'],
          filterDates: 'Any Time',
          filterDateStart: null,
          filterDateEnd: null,
          filterDoubleBooked: null,
          includeCompletedProjects: false
          // Default Filters - Needs to be updated if new filters are added to provide to the User Object
        },
        preConstruction: {
          showOnlyMyTasks: false,
          showOnlyMyProjects: false,
          filterVendors: null,
          filterVendorTypes: null,
          filterTasks: null,
          filterBuilders: null,
          filterPCTofProject: [0, 100],
          filterProjects: null,
          filterProjectTypes: 'Pre-Construction',
          filterProjectPhases: null,
          filterUsers: null,
          filterUserProjects: null,
          filterTaskStatus: null,
          filterDates: 'Any Time',
          filterDateStart: null,
          filterDateEnd: null,
          filterDoubleBooked: null,
          includeCompletedProjects: false
          // Default Filters - Needs to be updated if new filters are added to provide to the User Object
        },
        construction: {
          showOnlyMyTasks: false,
          showOnlyMyProjects: false,
          filterVendors: null,
          filterVendorTypes: null,
          filterTasks: null,
          filterBuilders: null,
          filterPCTofProject: [0, 100],
          filterProjects: null,
          filterProjectTypes: 'Construction',
          filterProjectPhases: null,
          filterUsers: null,
          filterUserProjects: null,
          filterTaskStatus: null,
          filterDates: 'Any Time',
          filterDateStart: null,
          filterDateEnd: null,
          filterDoubleBooked: null,
          includeCompletedProjects: false
          // Default Filters - Needs to be updated if new filters are added to provide to the User Object
        }
      }
      commit('setDefaultFilters', filters)
    },
    clearNotification ({ commit, getters, state }, payload) {
      const userIdString = 'users.' + getters.user.id
      const index = state.notifications.findIndex(i => i.id === payload)
      db.collection('notifications').doc(payload).update({
        [userIdString]: false
      })
        .then(() => {
          commit('clearNotification', index)
        })
    },
    notifications ({ commit, state }) { // Get Active Notifications for User
      let notifications = []
      const searchString = 'users.' + state.user.id
      db.collection('notifications').where(searchString, '==', true).get().then(response => {
        response.forEach(notification => {
          notifications.push({ ...notification.data(), id: notification.id })
        })
      })
        .then(() => {
          commit('notifications', notifications)
        })
    },
    notify ({ commit, getters }, payload) { // Requires - {emails: [], emailSubject: '', title: '', message: '', url: '', icon: ''}
      // Get Notification Package
      let userIds = {}
      let emails = []
      let allUsers = getters.userList
      payload.emails.forEach(email => {
        let user = allUsers.filter(f => f.email === email)[0]
        const name = user.first_name ? user.first_name + ' ' + user.last_name : ''
        userIds = { ...userIds, [user.id]: true }
        emails.push({ email: email, name: name })
      })
      const notification = { emails: emails, emailSubject: payload.emailSubject, title: payload.title, message: payload.message, url: payload.url, icon: payload.icon, users: userIds }
      // Write To Database (Function Automatically Sends Emails)
      const timestamp = new Date().getTime()
      db.collection('notifications').doc(String(timestamp)).set({ ...notification, timestamp: new Date() })
        .then(() => {
          // Finish Code to Add To Their Own Notifications : Would We Really Want To Do This?
          // const userString = 'users.' + getters.user.id
          // const ifCommit = notification.filter(f => f[userString] === true)
          // if (ifCommit && ifCommit.length > 0) {
          //   commit('pushNotification', { ...notification, timestamp: { seconds: new Date().getTime() / 1000 } })
          // }
          console.log('Success Writing to Notifications Database')
        })
    },
    loading ({ commit }, payload) {
      commit('setLoading', payload)
    },
    signUserIn ({ commit, state, dispatch }, payload) {
      auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          console.log('Successful Login')
          db.collection('users').doc(user.user.uid).get()
            .then(doc => {
              let userRole = null
              db.collection('roles').doc(doc.data().role).get().then(role => {
                userRole = role.data()
              })
                .then(() => {
                  let user = doc.data()
                  user = { ...user, id: doc.id, permissions: userRole }
                  commit('setUser', user)
                  const logData = { timestamp: new Date(), collection: 'users', type: 'login', user_id: user.id, record_id: user.id, message: user.first_name + ' logged in.', icon: 'mobile_friendly' }
                  dispatch('commitLog', logData)
                })
            })
        })
        .catch(error => {
          console.log('Error Logging In: ', error)
          state.authError = true
        })
    },
    signUserOut ({ commit, state, dispatch, getters }) {
      auth.signOut()
        .then(() => {
          console.log('Successful Logout')
          commit('clearUser')
          const logData = { timestamp: new Date(), collection: 'users', type: 'logout', user_id: getters.user.id, record_id: getters.user.id, message: getters.user.first_name + ' logged out.', icon: 'mobile_off' }
          dispatch('commitLog', logData)
        })
    },
    autoSignIn ({ commit }, payload) {
      db.collection('users').doc(payload.uid).get()
        .then(doc => {
          let userRole = null
          db.collection('roles').doc(doc.data().role).get().then(role => {
            userRole = role.data()
          })
            .then(() => {
              let user = doc.data()
              user = { ...user, id: doc.id, permissions: userRole }
              commit('setUser', user)
            })
        })
    },
    // A typical log entry an example of {timestamp: new Date(), collection: 'contacts', type: 'created', user_id: getters.user.id, record_id: docTimestamp, changed_from: {}, changed_to: {}, message: getters.user.first_name + ' created a new ' + payload.type + ': ' + payload.first_name + ' ' + payload.last_name, icon: logIcon}
    commitLog ({ commit, state }, payload) {
      const docTimestamp = String((new Date()).getTime()) + '-' + Math.floor(Math.random() * 10000)
      db.collection('log').doc(docTimestamp).set(payload)
        .then(() => { commit('commitLog', payload) })
        .catch(error => console.log('Could not save log event to database. Error: ', error))
    },
    setError ({ commit, state }, payload) {
      const docTimestamp = String((new Date()).getTime()) + '-' + Math.floor(Math.random() * 10000)
      db.collection('errors').doc(docTimestamp).set(payload)
        .then(() => { commit('setError', payload) })
        .catch(error => console.log('Could note write error to databas logs. Error: ', error))
    },
    clearError ({ commit, state }) {
      commit('clearError')
    },
    clientSettings ({ commit }, payload) {
      commit('clientSettings', payload)
    }
  },
  getters: {
    defaultFilters (state) {
      return state.defaultFilters
    },
    taskFilters (state) {
      return state.user.filters
    },
    notifications (state) {
      return state.notifications
    },
    user (state) {
      return state.user
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    authError (state) {
      return state.authError
    },
    clientSettings (state) {
      return state.clientSettings
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/main.js